export { default } from './share-button.component';
